import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://127.0.0.1:8000/api'

/**
 * Reports API service
 * Handles all report-related API calls
 */
export const reportsApi = {
  /**
   * Generate session report (returns JSON data)
   * @param {Object} filters - Report filters
   * @param {string} filters.from - Start date (YYYY-MM-DD)
   * @param {string} filters.to - End date (YYYY-MM-DD)
   * @param {number} filters.subject_id - School subject ID
   * @param {number} filters.group_id - Group ID
   * @param {number} filters.quiz_session_id - Quiz session ID
   * @param {string} filters.question_search - Question search term
   * @returns {Promise<Object>} Report data
   */
  async generateSessionReport(filters) {
    const token = localStorage.getItem('access_token')

    const response = await axios.get(`${API_BASE_URL}/reports/session`, {
      params: filters,
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })

    return response.data
  },

  /**
   * Download session report as PDF
   * @param {Object} filters - Report filters
   * @returns {Promise<Blob>} PDF blob
   */
  async downloadSessionReportPDF(filters) {
    const token = localStorage.getItem('access_token')

    const response = await axios.get(`${API_BASE_URL}/reports/session`, {
      params: filters,
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/pdf'
      },
      responseType: 'blob'
    })

    return response.data
  },

  /**
   * Stream session report as PDF (for viewing in browser)
   * @param {Object} filters - Report filters
   * @returns {Promise<Blob>} PDF blob
   */
  async streamSessionReportPDF(filters) {
    const token = localStorage.getItem('access_token')

    const response = await axios.get(`${API_BASE_URL}/reports/session/stream`, {
      params: filters,
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/pdf'
      },
      responseType: 'blob'
    })

    return response.data
  },

  /**
   * Preview report data (for debugging or data visualization)
   * @param {Object} filters - Report filters
   * @returns {Promise<Object>} Report preview data
   */
  async previewReportData(filters) {
    const token = localStorage.getItem('access_token')

    const response = await axios.get(`${API_BASE_URL}/reports/session/preview`, {
      params: filters,
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })

    return response.data
  }
}

export default reportsApi
